// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

body {
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #f5f5f5;
}

.App {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

.horizontal-layout {
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 20px;
  flex: 1 1;
}

.charger-tile,
.satellite-tile {
  background-color: #ffffff;
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 260px;
  min-height: 500px;
  box-shadow: 0 0 8px rgba(0,0,0,0.1);
  position: relative;
}

.charger-tile {
  /* większy box dla ładowarki */
  min-width: 300px;
  min-height: 420px;
}

.satellite-scroll {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
  flex: 1 1;
}

.device-image {
  width: 120px;
  height: auto;
  margin-bottom: 10px;
}

.form-column {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: auto;
}

.form-column label {
  font-size: 0.9rem;
  margin-top: 4px;
}

input, select {
  padding: 6px;
  font-size: 0.9rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
}

textarea {
  width: 100%;
  height: 200px;
  margin-top: 20px;
  font-family: monospace;
  font-size: 0.9rem;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  resize: vertical;
}

.bottom-controls {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 30px;
  flex-wrap: wrap;
}

.bottom-controls button {
  padding: 14px 28px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 10px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.bottom-controls button:hover {
  background-color: #0056b3;
}

/* zielony przycisk + przy każdej satelicie */
.satellite-tile .add-remove-buttons {
  position: absolute;
  right: 8px;
  bottom: 8px;
}

.add-remove-buttons button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  font-size: 1.2rem;
  color: white;
  background-color: #28a745;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* czerwony przycisk - */
.remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-error {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffe6e6;
  color: #a94442;
  border: 1px solid #f5c6cb;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
  text-align: center;
}

.popup-error button {
  margin-top: 10px;
  padding: 6px 12px;
  background-color: #a94442;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.popup-error button:hover {
  background-color: #922d2d;
}


/* Added styles */
.popup-error-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}


/* Added CSS for info popup */
.popup-info-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  z-index: 998;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-info {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #e7f5ff;
  color: #0b5394;
  border: 1px solid #b6d4fe;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
  text-align: center;
}

.popup-info button {
  margin-top: 10px;
  padding: 6px 12px;
  background-color: #0b5394;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.popup-info button:hover {
  background-color: #073c6b;
}

.commit-info {
  margin-top: 20px;
  text-align: center;
  font-size: 0.95rem;
  color: #333;
}

/* Added serialization input fields styles */
.serialization-fields {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
  width: 100%;
}

.serialization-options {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.serialization-options label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  width: 100%;
}

.serialization-options label span {
  white-space: nowrap;
}

.serialization-options input[type="checkbox"] {
  margin-left: 10px;
}


.checkbox-group {
  display: grid;
  grid-template-columns: 90% 1fr;
  grid-row-gap: 8px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.checkbox-group span {
  text-align: left;
}

.checkbox-group label {
  display: contents;
}

.checkbox-group input[type="checkbox"] {
  justify-self: end;
}

.top-bar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.top-bar h1 {
  margin: 0;
}

.top-actions {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 8px;
  align-items: center;
}

.top-action-button {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.15);

  background: rgba(255,255,255,0.08);
  color: inherit;

  font-weight: 700;
  cursor: pointer;
}

.top-action-button:hover {
  background: rgba(255,255,255,0.14);
}

.auth-screen {
  align-items: center;
  justify-content: center;
}

.auth-panel {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0,0,0,0.1);
  color: #333;
  padding: 28px;
  text-align: center;
}

.auth-panel-error {
  background-color: #ffe6e6;
  border-color: #f5c6cb;
  color: #a94442;
}

.auth-panel button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background-color: #0b5394;
  color: white;
  cursor: pointer;
}

.app-footer {
  margin-top: auto;
  padding-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #555;
  font-size: 0.85rem;
}

.app-version-info {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}

.feedback-button {
  padding: 8px 12px;
  border: 1px solid #c8d3df;
  border-radius: 6px;
  background: #ffffff;
  color: #0b5394;
  font-weight: 700;
  cursor: pointer;
}

.feedback-button:hover {
  background: #eef6ff;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(20, 28, 36, 0.54);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.feedback-modal {
  width: min(680px, 100%);
  max-height: calc(100vh - 40px);
  overflow: auto;
  background: #ffffff;
  color: #222;
  border-radius: 8px;
  border: 1px solid rgba(12, 32, 54, 0.12);
  box-shadow: 0 18px 48px rgba(0,0,0,0.24);
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.feedback-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
  border-bottom: 1px solid #e8edf2;
  background: #f8fafc;
}

.feedback-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  line-height: 1.2;
  color: #17212b;
}

.feedback-modal-header p {
  margin: 6px 0 0;
  color: #5f6f7f;
  font-size: 0.9rem;
  line-height: 1.35;
}

.modal-close-button {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #526271;
  cursor: pointer;
  font-size: 1.3rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close-button:hover {
  background: #e9eef3;
  color: #17212b;
}

.feedback-context {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 18px 24px 0;
  margin-bottom: 16px;
  color: #555;
  font-size: 0.88rem;
}

.feedback-context-item {
  min-width: 0;
  border: 1px solid #e1e7ee;
  border-radius: 8px;
  background: #fbfcfd;
  padding: 10px 12px;
  box-sizing: border-box;
}

.feedback-context-item span {
  display: block;
  margin-bottom: 4px;
  color: #6b7b8a;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
}

.feedback-context-item b {
  display: block;
  min-width: 0;
  color: #1f2a35;
  font-size: 0.9rem;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.feedback-field {
  padding: 0 24px;
}

.feedback-textarea-label {
  display: block;
  color: #333;
  font-weight: 700;
  margin-bottom: 10px;
}

.feedback-textarea {
  display: block;
  min-height: 180px;
  max-height: 34vh;
  margin-top: 0;
  font-family: Arial, sans-serif;
  font-size: 0.95rem;
  line-height: 1.45;
  border-color: #c9d5e0;
  border-radius: 8px;
  resize: vertical;
}

.feedback-textarea:focus {
  border-color: #0b5394;
  box-shadow: 0 0 0 3px rgba(11, 83, 148, 0.14);
  outline: none;
}

.feedback-helper {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  color: #667789;
  font-size: 0.78rem;
  line-height: 1.3;
}

.feedback-helper span:last-child {
  flex: 0 0 auto;
}

.feedback-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
  padding: 16px 24px 22px;
  border-top: 1px solid #edf1f5;
  background: #ffffff;
}

.primary-button,
.secondary-button {
  min-height: 40px;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.92rem;
}

.primary-button {
  border: 1px solid #0b5394;
  background: #0b5394;
  color: white;
}

.primary-button:hover:not(:disabled) {
  background: #073c6b;
}

.secondary-button {
  border: 1px solid #c8d3df;
  background: white;
  color: #333;
}

.secondary-button:hover:not(:disabled) {
  background: #f3f6f8;
}

.primary-button:disabled,
.secondary-button:disabled,
.modal-close-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

@media (max-width: 720px) {
  .app-footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .modal-overlay {
    align-items: flex-end;
    padding: 12px;
  }

  .feedback-modal {
    width: 100%;
    max-height: calc(100vh - 24px);
  }

  .feedback-modal-header {
    padding: 18px 18px 14px;
  }

  .feedback-context {
    grid-template-columns: 1fr;
    padding: 14px 18px 0;
  }

  .feedback-field {
    padding: 0 18px;
  }

  .feedback-textarea {
    min-height: 150px;
    max-height: 28vh;
  }

  .feedback-helper {
    flex-direction: column;
    gap: 4px;
  }

  .feedback-modal-actions {
    flex-direction: column-reverse;
    padding: 14px 18px 18px;
  }

  .primary-button,
  .secondary-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,SAAS;EACT,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;AACT;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;;EAExC,kCAAkC;EAClC,cAAc;;EAEd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,wCAAwC;EACxC,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* App.css */\n\nbody {\n  margin: 0;\n  font-family: Arial, sans-serif;\n  background-color: #f5f5f5;\n}\n\n.App {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  box-sizing: border-box;\n}\n\nh1 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.horizontal-layout {\n  display: flex;\n  flex-direction: row;\n  gap: 40px;\n  align-items: flex-start;\n  justify-content: center;\n  margin-bottom: 20px;\n  flex: 1;\n}\n\n.charger-tile,\n.satellite-tile {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  padding: 16px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 260px;\n  min-height: 500px;\n  box-shadow: 0 0 8px rgba(0,0,0,0.1);\n  position: relative;\n}\n\n.charger-tile {\n  /* większy box dla ładowarki */\n  min-width: 300px;\n  min-height: 420px;\n}\n\n.satellite-scroll {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 16px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n  flex: 1;\n}\n\n.device-image {\n  width: 120px;\n  height: auto;\n  margin-bottom: 10px;\n}\n\n.form-column {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: auto;\n}\n\n.form-column label {\n  font-size: 0.9rem;\n  margin-top: 4px;\n}\n\ninput, select {\n  padding: 6px;\n  font-size: 0.9rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\ntextarea {\n  width: 100%;\n  height: 200px;\n  margin-top: 20px;\n  font-family: monospace;\n  font-size: 0.9rem;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  resize: vertical;\n}\n\n.bottom-controls {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 30px;\n  flex-wrap: wrap;\n}\n\n.bottom-controls button {\n  padding: 14px 28px;\n  font-size: 1rem;\n  font-weight: bold;\n  border-radius: 10px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.bottom-controls button:hover {\n  background-color: #0056b3;\n}\n\n/* zielony przycisk + przy każdej satelicie */\n.satellite-tile .add-remove-buttons {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n}\n\n.add-remove-buttons button {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  font-size: 1.2rem;\n  color: white;\n  background-color: #28a745;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* czerwony przycisk - */\n.remove-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  font-size: 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.popup-error {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #ffe6e6;\n  color: #a94442;\n  border: 1px solid #f5c6cb;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  z-index: 1000;\n  text-align: center;\n}\n\n.popup-error button {\n  margin-top: 10px;\n  padding: 6px 12px;\n  background-color: #a94442;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.popup-error button:hover {\n  background-color: #922d2d;\n}\n\n\n/* Added styles */\n.popup-error-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.5);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n/* Added CSS for info popup */\n.popup-info-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.4);\n  z-index: 998;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.popup-info {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #e7f5ff;\n  color: #0b5394;\n  border: 1px solid #b6d4fe;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  z-index: 1000;\n  text-align: center;\n}\n\n.popup-info button {\n  margin-top: 10px;\n  padding: 6px 12px;\n  background-color: #0b5394;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.popup-info button:hover {\n  background-color: #073c6b;\n}\n\n.commit-info {\n  margin-top: 20px;\n  text-align: center;\n  font-size: 0.95rem;\n  color: #333;\n}\n\n/* Added serialization input fields styles */\n.serialization-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 10px;\n  width: 100%;\n}\n\n.serialization-options {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.serialization-options label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.9rem;\n  width: 100%;\n}\n\n.serialization-options label span {\n  white-space: nowrap;\n}\n\n.serialization-options input[type=\"checkbox\"] {\n  margin-left: 10px;\n}\n\n\n.checkbox-group {\n  display: grid;\n  grid-template-columns: 90% 1fr;\n  grid-row-gap: 8px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.checkbox-group span {\n  text-align: left;\n}\n\n.checkbox-group label {\n  display: contents;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  justify-self: end;\n}\n\n.top-bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.top-bar h1 {\n  margin: 0;\n}\n\n.top-actions {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.top-action-button {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid rgba(255,255,255,0.15);\n\n  background: rgba(255,255,255,0.08);\n  color: inherit;\n\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.top-action-button:hover {\n  background: rgba(255,255,255,0.14);\n}\n\n.auth-screen {\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-panel {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 0 8px rgba(0,0,0,0.1);\n  color: #333;\n  padding: 28px;\n  text-align: center;\n}\n\n.auth-panel-error {\n  background-color: #ffe6e6;\n  border-color: #f5c6cb;\n  color: #a94442;\n}\n\n.auth-panel button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  background-color: #0b5394;\n  color: white;\n  cursor: pointer;\n}\n\n.app-footer {\n  margin-top: auto;\n  padding-top: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  color: #555;\n  font-size: 0.85rem;\n}\n\n.app-version-info {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.feedback-button {\n  padding: 8px 12px;\n  border: 1px solid #c8d3df;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #0b5394;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.feedback-button:hover {\n  background: #eef6ff;\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(20, 28, 36, 0.54);\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.feedback-modal {\n  width: min(680px, 100%);\n  max-height: calc(100vh - 40px);\n  overflow: auto;\n  background: #ffffff;\n  color: #222;\n  border-radius: 8px;\n  border: 1px solid rgba(12, 32, 54, 0.12);\n  box-shadow: 0 18px 48px rgba(0,0,0,0.24);\n  padding: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.feedback-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 24px 16px;\n  border-bottom: 1px solid #e8edf2;\n  background: #f8fafc;\n}\n\n.feedback-modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  line-height: 1.2;\n  color: #17212b;\n}\n\n.feedback-modal-header p {\n  margin: 6px 0 0;\n  color: #5f6f7f;\n  font-size: 0.9rem;\n  line-height: 1.35;\n}\n\n.modal-close-button {\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #526271;\n  cursor: pointer;\n  font-size: 1.3rem;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close-button:hover {\n  background: #e9eef3;\n  color: #17212b;\n}\n\n.feedback-context {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  padding: 18px 24px 0;\n  margin-bottom: 16px;\n  color: #555;\n  font-size: 0.88rem;\n}\n\n.feedback-context-item {\n  min-width: 0;\n  border: 1px solid #e1e7ee;\n  border-radius: 8px;\n  background: #fbfcfd;\n  padding: 10px 12px;\n  box-sizing: border-box;\n}\n\n.feedback-context-item span {\n  display: block;\n  margin-bottom: 4px;\n  color: #6b7b8a;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.feedback-context-item b {\n  display: block;\n  min-width: 0;\n  color: #1f2a35;\n  font-size: 0.9rem;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.feedback-field {\n  padding: 0 24px;\n}\n\n.feedback-textarea-label {\n  display: block;\n  color: #333;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.feedback-textarea {\n  display: block;\n  min-height: 180px;\n  max-height: 34vh;\n  margin-top: 0;\n  font-family: Arial, sans-serif;\n  font-size: 0.95rem;\n  line-height: 1.45;\n  border-color: #c9d5e0;\n  border-radius: 8px;\n  resize: vertical;\n}\n\n.feedback-textarea:focus {\n  border-color: #0b5394;\n  box-shadow: 0 0 0 3px rgba(11, 83, 148, 0.14);\n  outline: none;\n}\n\n.feedback-helper {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n  color: #667789;\n  font-size: 0.78rem;\n  line-height: 1.3;\n}\n\n.feedback-helper span:last-child {\n  flex: 0 0 auto;\n}\n\n.feedback-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 18px;\n  padding: 16px 24px 22px;\n  border-top: 1px solid #edf1f5;\n  background: #ffffff;\n}\n\n.primary-button,\n.secondary-button {\n  min-height: 40px;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 0.92rem;\n}\n\n.primary-button {\n  border: 1px solid #0b5394;\n  background: #0b5394;\n  color: white;\n}\n\n.primary-button:hover:not(:disabled) {\n  background: #073c6b;\n}\n\n.secondary-button {\n  border: 1px solid #c8d3df;\n  background: white;\n  color: #333;\n}\n\n.secondary-button:hover:not(:disabled) {\n  background: #f3f6f8;\n}\n\n.primary-button:disabled,\n.secondary-button:disabled,\n.modal-close-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n@media (max-width: 720px) {\n  .app-footer {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .modal-overlay {\n    align-items: flex-end;\n    padding: 12px;\n  }\n\n  .feedback-modal {\n    width: 100%;\n    max-height: calc(100vh - 24px);\n  }\n\n  .feedback-modal-header {\n    padding: 18px 18px 14px;\n  }\n\n  .feedback-context {\n    grid-template-columns: 1fr;\n    padding: 14px 18px 0;\n  }\n\n  .feedback-field {\n    padding: 0 18px;\n  }\n\n  .feedback-textarea {\n    min-height: 150px;\n    max-height: 28vh;\n  }\n\n  .feedback-helper {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .feedback-modal-actions {\n    flex-direction: column-reverse;\n    padding: 14px 18px 18px;\n  }\n\n  .primary-button,\n  .secondary-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
